import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[rk] UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.compact) {
      return (
        <div className="p-4 text-sm text-slate-700" data-testid="error-boundary-compact">
          Terjadi gangguan tampilan.{" "}
          <button onClick={() => this.setState({ error: null })} className="font-semibold text-[#D97706] underline">Coba lagi</button>
        </div>
      );
    }
    return (
      <div className="grid min-h-screen place-items-center p-8 text-center" data-testid="error-boundary">
        <div>
          <p className="text-lg font-bold text-[#0F2B48]">Maaf, halaman mengalami gangguan.</p>
          <button onClick={() => window.location.reload()} className="mt-4 bg-[#0F2B48] px-5 py-2.5 text-sm font-bold text-white">Muat Ulang</button>
        </div>
      </div>
    );
  }
}
